export enum ShipmentStatus {
	Active = "Active",
	Completed = "Completed",
	Cancelled = "Cancelled",
}

const shipmentStatusColors: Record<ShipmentStatus, string> = {
	[ShipmentStatus.Active]: "#d5ffc1",
	[ShipmentStatus.Completed]: "#ffe4b5",
	[ShipmentStatus.Cancelled]: "#ffd9d9",
}

export function getShipmentStatusColor(status: ShipmentStatus) {
	return shipmentStatusColors[status]
}
